import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PasswordChangeRequestBody, PasswordChangeResponse } from "./types";

export class PasswordChangeAPI extends BaseAPI<
  PasswordChangeRequestBody,
  PasswordChangeResponse
> {
  protected route = ApiRoutes.auth.password_change;
  protected method = RequestMethod.POST;
}
